var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{staticClass:"text-center",attrs:{"show":_vm.show},on:{"close":function($event){return _vm.close()}}},[_c('div',{staticClass:"modal-main"},[_c('div',{staticClass:"modal-body"},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":"https://calendly.com/microba-microbiome-coach/15minute-microbiome-coach-session"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e09ed06","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/models/ModalBooking.vue
// module id = Ab0n
// module chunks = 1